export const REQUEST_FREQUENT_QUESTIONS = "REQUEST_FREQUENT_QUESTIONS";
